import {  ProfileComp } from "../components";

const Profile = () => {

  return (
 <ProfileComp/>
    
  );
};

export default Profile;
